"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validationRules = exports.getFieldValidator = exports.getFieldValidationRules = exports.getComponentValidator = exports.getComponentValidationRules = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _lodash = _interopRequireDefault(require("lodash"));

var _types = require("../../types");

var _componentValidationRules = require("./component/componentValidationRules");

var _fieldValidationRules = require("./field/fieldValidationRules");

var _config = require("../../components/config");

var _config2 = require("../../fields/config");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

// eslint-disable-next-line import/no-cycle
var ComponentElementDefinition = _flowRuntime["default"].tdz(function () {
  return _types.ComponentElementDefinition;
});

var ComponentRuleDefinition = _flowRuntime["default"].tdz(function () {
  return _types.ComponentRuleDefinition;
});

var FieldElementDefinition = _flowRuntime["default"].tdz(function () {
  return _types.FieldElementDefinition;
});

var FieldRuleDefinition = _flowRuntime["default"].tdz(function () {
  return _types.FieldRuleDefinition;
});

var InheritedFieldValidation = _flowRuntime["default"].tdz(function () {
  return _types.InheritedFieldValidation;
});

var InheritedComponentValidation = _flowRuntime["default"].tdz(function () {
  return _types.InheritedComponentValidation;
});

var Validator = _flowRuntime["default"].tdz(function () {
  return _types.Validator;
});

var getComponentValidator = function getComponentValidator(rule, componentKey) {
  if (rule.conditionRequired) {
    return (0, _componentValidationRules.conditionRequired)(componentKey);
  }

  if (rule.maxBmi) {
    return (0, _componentValidationRules.maxBmi)(rule.maxBmi, componentKey);
  }

  if (rule.minWeight) {
    return (0, _componentValidationRules.minWeight)(rule.minWeight, componentKey);
  }

  if (rule.personCategoryRequired) {
    return (0, _componentValidationRules.personCategoryRequired)(componentKey);
  }

  if (rule.personIdRequired) {
    return (0, _componentValidationRules.personIdRequired)(componentKey);
  }

  if (rule.phoneNumberRequired) {
    return (0, _componentValidationRules.phoneNumberRequired)(componentKey);
  }

  if (rule.receivedBloodTransfusionRequired) {
    return (0, _componentValidationRules.receivedBloodTransfusionRequired)(componentKey);
  }

  if (rule.refusedBloodDonorRequired) {
    return (0, _componentValidationRules.refusedBloodDonorRequired)(componentKey);
  }

  if (rule.fieldValidation) {
    return (0, _componentValidationRules.fieldValidation)(componentKey, rule.fieldValidation.field, rule.fieldValidation.validation);
  }

  if (rule.validateIfFieldMatchesValue) {
    return (0, _componentValidationRules.validateIfFieldMatchesValue)(componentKey, rule.validateIfFieldMatchesValue.field, rule.validateIfFieldMatchesValue.value, rule.validateIfFieldMatchesValue.validation);
  } // eslint-disable-next-line no-console


  console.warn('Unknown component validation rule specified', rule);
  return function () {
    return undefined;
  };
};

exports.getComponentValidator = getComponentValidator;

var getComponentValidationRules = function getComponentValidationRules(component, componentKey) {
  var inheritedComponentValidation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var inheritedComponentValidationRules = inheritedComponentValidation.map(function (item) {
    return item.validation;
  });
  var componentConfig = (0, _config.getComponentConfig)(component);
  var validationRules = [].concat((0, _toConsumableArray2["default"])(_lodash["default"].get(component, 'validation', [])), (0, _toConsumableArray2["default"])(_lodash["default"].get(componentConfig, 'validation', [])), (0, _toConsumableArray2["default"])(_lodash["default"].flatten(inheritedComponentValidationRules)));
  return validationRules.map(function (rule) {
    return getComponentValidator(rule, componentKey);
  });
};

exports.getComponentValidationRules = getComponentValidationRules;

var getFieldValidator = function getFieldValidator(rule) {
  if (rule.required) {
    return _fieldValidationRules.required;
  }

  if (rule.min) {
    return (0, _fieldValidationRules.min)(rule.min);
  }

  if (rule.postcode) {
    return _fieldValidationRules.postcode;
  }

  if (rule.currency) {
    return _fieldValidationRules.currency;
  }

  if (rule.card) {
    return _fieldValidationRules.card;
  }

  if (rule.cvv) {
    return _fieldValidationRules.cvv;
  }

  if (rule.differentTo) {
    return (0, _fieldValidationRules.differentTo)(rule.differentTo);
  }

  if (rule.fixedLength) {
    return (0, _fieldValidationRules.fixedLength)(rule.fixedLength);
  }

  if (rule.phoneNumber) {
    return _fieldValidationRules.phoneNumber;
  }

  if (rule.ukLandlineNumber) {
    return _fieldValidationRules.ukLandlineNumber;
  }

  if (rule.ukMobileNumber) {
    return _fieldValidationRules.ukMobileNumber;
  }

  if (rule.email) {
    return _fieldValidationRules.email;
  }

  if (rule.notAcademicEmail) {
    return _fieldValidationRules.notAcademicEmail;
  }

  if (rule.date) {
    return _fieldValidationRules.date;
  }

  if (rule.babyDueDate) {
    return _fieldValidationRules.babyDueDate;
  }

  if (rule.age) {
    return _fieldValidationRules.age;
  }

  if (rule.ageRange) {
    return (0, _fieldValidationRules.ageRange)(rule.ageRange.minimumAge, rule.ageRange.maximumAge, rule.ageRange.message);
  }

  if (rule.failValue) {
    return (0, _fieldValidationRules.failValue)(rule.failValue);
  }

  if (rule.requiredValue) {
    return (0, _fieldValidationRules.requiredValue)(rule.requiredValue);
  }

  if (rule.donorId) {
    return _fieldValidationRules.donorId;
  }

  if (rule.uuid) {
    return _fieldValidationRules.uuid;
  }

  if (rule.supporterId) {
    return _fieldValidationRules.supporterId;
  } // eslint-disable-next-line no-console


  console.warn('Unknown field validation rule specified', rule);
  return function () {
    return undefined;
  };
};

exports.getFieldValidator = getFieldValidator;

var validationRules = function validationRules(field) {
  var inheritedFieldValidation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var inheritedFieldValidationRules = inheritedFieldValidation.map(function (item) {
    return item.validation;
  });
  var fieldConfig = (0, _config2.getFieldConfig)(field);
  return [].concat((0, _toConsumableArray2["default"])(_lodash["default"].get(field, 'validation', [])), (0, _toConsumableArray2["default"])(_lodash["default"].get(fieldConfig, 'validation', [])), (0, _toConsumableArray2["default"])(_lodash["default"].flatten(inheritedFieldValidationRules)));
};

exports.validationRules = validationRules;

var getFieldValidationRules = function getFieldValidationRules(field) {
  var inheritedFieldValidation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return validationRules(field, inheritedFieldValidation).map(getFieldValidator);
};

exports.getFieldValidationRules = getFieldValidationRules;